// extracted by mini-css-extract-plugin
export default {"container":"SignupForm_container__u8+cn","title":"SignupForm_title__cj0iV","form":"SignupForm_form__lyi1d","submit":"SignupForm_submit__qL+Bc"};